"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  de: {
    collapseTextOverlayOptions: 'OCR-Optionen einklappen',
    disableTextOverlay: 'OCR deaktivieren',
    enableTextOverlay: 'OCR aktivieren',
    expandTextOverlayOptions: 'OCR-Optionen ausklappen',
    overlayOpacity: 'Transparenz',
    overlayVisible: 'OCR Anzeigen/Verbergen',
    colorPicker: 'Farbauswahl',
    color: 'Farbe',
    resetColor: 'Farbe zurücksetzen',
    ocrCorrectionTooltip: 'Fehler melden',
    ocrCorrectionSubject: 'OCR-Fehler melden',
    ocrCorrectionBody: "------\nIm Browser anschauen: {{url}}\n-----\n{{metadata}}\nSignatur: {{signature}}\n\nSeite: {{page}}\nZeile: \"{{text}}\"\n-----\n\n\nVorgeschlagene Korrektur:\n-----\n\n"
  },
  en: {
    collapseTextOverlayOptions: 'Collapse OCR options',
    disableTextOverlay: 'Disable OCR',
    enableTextOverlay: 'Enable OCR',
    expandTextOverlayOptions: 'Expand OCR options',
    overlayOpacity: 'Opacity',
    overlayVisible: 'Show/Hide OCR',
    colorPicker: 'Color picker',
    color: 'Color',
    resetColor: 'Reset color',
    ocrCorrectionTooltip: 'Report error',
    ocrCorrectionSubject: 'Reporting OCR error',
    ocrCorrectionBody: "------\nShow in browser: {{url}}\n------\n{{metadata}}\nSignature: {{signature}}\n\nPage: {{page}}\nLine: \"{{text}}\"\n-----\n\n\nsuggested correction:\n-----\n\n"
  }
};
exports["default"] = _default;